import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Star } from "lucide-react";
import { toast } from "sonner";

export default function ReviewDialog({ open, onOpenChange, booking, onSubmitted }) {
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    setSaving(true);
    try {
      await api.post("/reviews", { experience_id: booking.experience_id, rating, comment });
      toast.success("Review posted — thank you.");
      onSubmitted?.();
      onOpenChange(false);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Failed to submit");
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-canvas">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">Reflect on {booking?.experience_title}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div>
            <div className="text-xs text-muted2 mb-2">Your rating</div>
            <div className="flex gap-1" data-testid="rating-stars">
              {[1, 2, 3, 4, 5].map((n) => (
                <button key={n} data-testid={`star-${n}`} onClick={() => setRating(n)} type="button">
                  <Star className={`h-7 w-7 ${n <= rating ? "fill-terracotta text-terracotta" : "text-subtle"}`} strokeWidth={1.5} />
                </button>
              ))}
            </div>
          </div>
          <div>
            <div className="text-xs text-muted2 mb-2">Words for future travelers</div>
            <Textarea data-testid="review-comment" rows={5} value={comment} onChange={(e) => setComment(e.target.value)} placeholder="Share what shifted in you…" className="bg-white border-subtle rounded-xl" />
          </div>
        </div>
        <DialogFooter>
          <Button data-testid="submit-review" onClick={submit} disabled={saving} className="rounded-full bg-moss hover:bg-moss-hover text-canvas">
            {saving ? "Posting…" : "Post review"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
